import axios from "axios";
import Config from "src/config";

const v1_actionDeletarFigurinha = (id, querys) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/figurinhas/${id}${querys}`,
    });
};

export default v1_actionDeletarFigurinha;
